import React, { useEffect, useState } from "react";
import DoubleButton from "../DoubleButton";
import styled from "styled-components";
import { useAlert, useGroupPosition } from "src/hooks";
import { useRecoilState } from "recoil";
import { recoilStates } from "src/recoil/recoilStates";
import { colors } from "src/styles/theme";
import { TeamSubmitDataType } from "src/types";
import { usePopupSelectV2 } from "../PopupSelect";

// 조 추가 모달 컴포넌트
const AddJoModal = ({
  isOpen,
  onClose,
  onAddTeams,
}: {
  isOpen: boolean;
  onClose: () => void;
  onAddTeams: (count: number) => void;
}) => {
  const [selectedOption, setSelectedOption] = useState("5");

  const handleOptionSelect = (value: string) => {
    setSelectedOption(value);
  };

  const handleCancel = () => {
    onClose();
  };

  const handleSelect = () => {
    onAddTeams(parseInt(selectedOption));
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="addjo-page">
      <div className="addjo-modal">
        <div className="addjo-modal-container">
          <div className="addjo-modal-content">
            <h1 className="addjo-modal-title">조 추가</h1>

            <div className="addjo-options-container">
              <div
                className={`addjo-option-button ${selectedOption === "5" ? "active" : "default"}`}
                onClick={() => handleOptionSelect("5")}
              >
                <div className="addjo-option-content">
                  <div className="addjo-option-left">
                    <div className="check-circle-wrapper">
                      <div className="check-circle-background"></div>
                      <svg
                        className={`check-circle-icon ${selectedOption === "5" ? "active" : ""}`}
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M7.83317 12.8334L13.7082 6.95842L12.5415 5.79175L7.83317 10.5001L5.45817 8.12508L4.2915 9.29175L7.83317 12.8334ZM8.99984 17.3334C7.84706 17.3334 6.76373 17.1147 5.74984 16.6772C4.73595 16.2397 3.854 15.6459 3.104 14.8959C2.354 14.1459 1.76025 13.264 1.32275 12.2501C0.885254 11.2362 0.666504 10.1529 0.666504 9.00008C0.666504 7.8473 0.885254 6.76397 1.32275 5.75008C1.76025 4.73619 2.354 3.85425 3.104 3.10425C3.854 2.35425 4.73595 1.7605 5.74984 1.323C6.76373 0.885498 7.84706 0.666748 8.99984 0.666748C10.1526 0.666748 11.2359 0.885498 12.2498 1.323C13.2637 1.7605 14.1457 2.35425 14.8957 3.10425C15.6457 3.85425 16.2394 4.73619 16.6769 5.75008C17.1144 6.76397 17.3332 7.8473 17.3332 9.00008C17.3332 10.1529 17.1144 11.2362 16.6769 12.2501C16.2394 13.264 15.6457 14.1459 14.8957 14.8959C14.1457 15.6459 13.2637 16.2397 12.2498 16.6772C11.2359 17.1147 10.1526 17.3334 8.99984 17.3334Z"
                          fill={selectedOption === "5" ? "#007BFF" : "#D1D5D8"}
                        />
                      </svg>
                    </div>
                    <span className="addjo-option-text">5개 조 추가</span>
                  </div>
                </div>
              </div>

              <div
                className={`addjo-option-button ${selectedOption === "10" ? "active" : "default"}`}
                onClick={() => handleOptionSelect("10")}
              >
                <div className="addjo-option-content">
                  <div className="addjo-option-left">
                    <div className="check-circle-wrapper">
                      <div className="check-circle-background"></div>
                      <svg
                        className={`check-circle-icon ${selectedOption === "10" ? "active" : ""}`}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M6.81745 11.5447L12.42 5.94221L11.5418 5.06409L6.81745 9.78846L4.44245 7.41346L3.56433 8.29158L6.81745 11.5447ZM8.00162 15.9166C6.90662 15.9166 5.87738 15.7088 4.91391 15.2933C3.95044 14.8777 3.11238 14.3137 2.39975 13.6014C1.68711 12.889 1.12287 12.0513 0.707038 11.0883C0.291343 10.1252 0.0834961 9.09624 0.0834961 8.00138C0.0834961 6.90638 0.291274 5.87714 0.706829 4.91367C1.12238 3.9502 1.68634 3.11214 2.3987 2.3995C3.11107 1.68686 3.94877 1.12263 4.91183 0.706793C5.87489 0.291099 6.90384 0.083252 7.9987 0.083252C9.0937 0.083252 10.1229 0.291029 11.0864 0.706585C12.0499 1.12214 12.8879 1.6861 13.6006 2.39846C14.3132 3.11082 14.8775 3.94853 15.2933 4.91159C15.709 5.87464 15.9168 6.9036 15.9168 7.99846C15.9168 9.09346 15.7091 10.1227 15.2935 11.0862C14.8779 12.0496 14.314 12.8877 13.6016 13.6003C12.8893 14.313 12.0516 14.8772 11.0885 15.293C10.1254 15.7087 9.09648 15.9166 8.00162 15.9166ZM8.00016 14.6666C9.86127 14.6666 11.4377 14.0208 12.7293 12.7291C14.021 11.4374 14.6668 9.86103 14.6668 7.99992C14.6668 6.13881 14.021 4.56242 12.7293 3.27075C11.4377 1.97909 9.86127 1.33325 8.00016 1.33325C6.13905 1.33325 4.56266 1.97909 3.271 3.27075C1.97933 4.56242 1.3335 6.13881 1.3335 7.99992C1.3335 9.86103 1.97933 11.4374 3.271 12.7291C4.56266 14.0208 6.13905 14.6666 8.00016 14.6666Z"
                          fill={selectedOption === "10" ? "#007BFF" : "#D1D5D8"}
                        />
                      </svg>
                    </div>
                    <span className="addjo-option-text">10개 조 추가</span>
                  </div>
                </div>
              </div>

              <div
                className={`addjo-option-button ${selectedOption === "15" ? "active" : "default"}`}
                onClick={() => handleOptionSelect("15")}
              >
                <div className="addjo-option-content">
                  <div className="addjo-option-left">
                    <div className="check-circle-wrapper">
                      <div className="check-circle-background"></div>
                      <svg
                        className={`check-circle-icon ${selectedOption === "15" ? "active" : ""}`}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M6.81745 11.5447L12.42 5.94221L11.5418 5.06409L6.81745 9.78846L4.44245 7.41346L3.56433 8.29158L6.81745 11.5447ZM8.00162 15.9166C6.90662 15.9166 5.87738 15.7088 4.91391 15.2933C3.95044 14.8777 3.11238 14.3137 2.39975 13.6014C1.68711 12.889 1.12287 12.0513 0.707038 11.0883C0.291343 10.1252 0.0834961 9.09624 0.0834961 8.00138C0.0834961 6.90638 0.291274 5.87714 0.706829 4.91367C1.12238 3.9502 1.68634 3.11214 2.3987 2.3995C3.11107 1.68686 3.94877 1.12263 4.91183 0.706793C5.87489 0.291099 6.90384 0.083252 7.9987 0.083252C9.0937 0.083252 10.1229 0.291029 11.0864 0.706585C12.0499 1.12214 12.8879 1.6861 13.6006 2.39846C14.3132 3.11082 14.8775 3.94853 15.2933 4.91159C15.709 5.87464 15.9168 6.9036 15.9168 7.99846C15.9168 9.09346 15.7091 10.1227 15.2935 11.0862C14.8779 12.0496 14.314 12.8877 13.6016 13.6003C12.8893 14.313 12.0516 14.8772 11.0885 15.293C10.1254 15.7087 9.09648 15.9166 8.00162 15.9166ZM8.00016 14.6666C9.86127 14.6666 11.4377 14.0208 12.7293 12.7291C14.021 11.4374 14.6668 9.86103 14.6668 7.99992C14.6668 6.13881 14.021 4.56242 12.7293 3.27075C11.4377 1.97909 9.86127 1.33325 8.00016 1.33325C6.13905 1.33325 4.56266 1.97909 3.271 3.27075C1.97933 4.56242 1.3335 6.13881 1.3335 7.99992C1.3335 9.86103 1.97933 11.4374 3.271 12.7291C4.56266 14.0208 6.13905 14.6666 8.00016 14.6666Z"
                          fill={selectedOption === "15" ? "#007BFF" : "#D1D5D8"}
                        />
                      </svg>
                    </div>
                    <span className="addjo-option-text">15개 조 추가</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="addjo-modal-buttons">
          <button className="addjo-cancel-button" onClick={handleCancel}>
            취소
          </button>
          <button className="addjo-select-button" onClick={handleSelect}>
            선택하기
          </button>
        </div>
      </div>
    </div>
  );
};

const TeamSelector = (props: {
  teams: TeamSubmitDataType;
  memberId: number;
  setTeams: React.Dispatch<React.SetStateAction<TeamSubmitDataType | undefined>>;
}) => {
  // console.log("props.teams :", props.teams);
  // let default1

  const rowTeam = props.teams.find((t) => {
    return t.members.some((m) => m.member_id === props.memberId);
  });

  const { PopupSelect, activeIds, propsToInject, reset } = usePopupSelectV2({
    defaultSelectIds: [rowTeam?.team_number || 0],
  });

  const items = props.teams.map((t: any) => {
    return { id: t.team_number, name: `${t.team_number} 조` };
  });

  const alert = useAlert();

  return (
    <>
      <PopupSelect
        {...propsToInject}
        $resultFullWidth
        $resultCenter
        label="조 편성"
        isHiddenLabel
        items={[...items]}
        size="sm"
        onSubmit={(id, isUnSelect) => {
          const newTeamNumber = id?.[0];

          if (isUnSelect) {
            props.setTeams((prev) => {
              const oldTeamNumber = rowTeam?.team_number;
              const tar2 = prev?.find((t) => t.team_number === oldTeamNumber);
              if (tar2) {
                tar2.members = tar2?.members?.filter((m) => m.member_id !== props.memberId);
              }
              return [...(prev || [])];
            });
            return;
          } else {
            props.setTeams((prev) => {
              const tar = prev?.find((t) => t.team_number === newTeamNumber);
              if (tar?.members?.length === 4) {
                alert("팀당 인원은 최대 4명까지 입니다.");
                return [...(prev || [])];
              }

              if (rowTeam?.team_number) {
                // 기존 타 팀 멤버였으면 제거
                const oldTeamNumber = rowTeam?.team_number;
                const tar2 = prev?.find((t) => t.team_number === oldTeamNumber);
                if (!tar2) {
                  return;
                }
                tar2.members = tar2?.members?.filter((m) => m.member_id !== props.memberId);
              }

              tar?.members.push({ member_id: props.memberId });

              return [...(prev || [])];
            });
          }
          // console.log('submit done id:', id);
        }}
      />
    </>
  );
};

const AddTeamCountObjArr = [
  { id: 5, name: "5개 조 추가" },
  { id: 10, name: "10개 조 추가" },
  { id: 15, name: "15개 조 추가" },
];

export default function MemberSearchPopupContentsEvent(props: {
  handleSubmit: (tempSave: boolean) => void;
  closeMe: () => void;
  setTeams: React.Dispatch<React.SetStateAction<TeamSubmitDataType | undefined>>;
  teams: TeamSubmitDataType;
  isFixed: boolean;
  maxTeams?: number;
  onAddTeams?: (count: number) => void;
}) {
  const [eventApplication] = useRecoilState(recoilStates.eventApplication);

  const [memberData, setMemberData] = useState([...(eventApplication?.members || [])]);
  const [isAddJoModalOpen, setIsAddJoModalOpen] = useState(false);

  const positions = useGroupPosition();

  useEffect(() => {
    if (!props?.teams?.length) {
      return;
    }
    setMemberData((prev) => {
      prev?.sort((a, b) => {
        const teamNumberA =
          props.teams.find((t) => t.members.find((m) => m.member_id === a.id))?.team_number ||
          99999;
        const teamNumberB =
          props.teams.find((t) => t.members.find((m) => m.member_id === b.id))?.team_number ||
          99999;

        return teamNumberA - teamNumberB;
      });
      return [...(prev || [])];
    });
  }, [props.teams]);

  const handleAddTeams = (count: number) => {
    if (props.onAddTeams) {
      props.onAddTeams(count);
    } else {
      // 기존 로직 (fallback)
      props.setTeams((prev) => {
        if (!prev) {
          return [...(prev || [])];
        }

        prev.sort((a, b) => a.team_number - b.team_number);
        const lastTeamNumber = prev[prev.length - 1]?.team_number;

        for (let i = 1; i <= count; i++) {
          prev.push({ team_number: lastTeamNumber + i, members: [] });
        }

        return [...(prev || [])];
      });
    }
  };
  return (
    <Container className="flex-1 d-flex fd-c">
      <div className="flex-1">
        {!memberData || memberData.length < 1 ? (
          <>멤버가 없습니다.</>
        ) : (
          <>
            <p>
              멤버수: <span className="fc-red">{memberData.length}</span> 명
            </p>

            <div className="list-table">
              <div className="t-header">
                <div className="item">선택</div>
                <div className="item">직책</div>
                <div className="item">이름</div>
                <div className="item">연락처</div>
              </div>
              <ul className="member-list">
                {memberData.map((m) => {
                  return (
                    <li key={m.id}>
                      <div className="item d-flex jc-c">
                        <div className={`check-container flex-1 d-flex jc-c ai-c`}>
                          {props.isFixed ? (
                            (() => {
                              const team = props.teams.find((t) =>
                                t.members.some((_m) => _m.member_id === m.id)
                              );
                              return team ? `${team.team_number} 조` : "-";
                            })()
                          ) : (
                            <TeamSelector
                              teams={props.teams}
                              memberId={m.id}
                              setTeams={props.setTeams}
                            />
                          )}
                        </div>
                      </div>
                      <div className="item">
                        {positions?.find((p) => p.id === m.member_level_id)?.name}
                      </div>
                      <div className="item">{m.name}</div>
                      <div className="item">{m.phone_number}</div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </>
        )}
      </div>

      <div className="fc-red fs-3">★ 조편성을 임시저장할 수 있습니다.</div>
      <DoubleButton
        nagativeMargin
        left={{
          name: "조 추가",
          size: "md",
          buttonCompProps: { disabled: props.isFixed },
          themeColor: "lightGray",
          onClick: () => {
            setIsAddJoModalOpen(true);
          },
        }}
        right={{
          name: "임시저장",
          buttonCompProps: { disabled: props.isFixed },
          size: "md",
          themeColor: "green",
          onClick: () => {
            props.handleSubmit(true);
          },
        }}
      />

      <AddJoModal
        isOpen={isAddJoModalOpen}
        onClose={() => setIsAddJoModalOpen(false)}
        onAddTeams={handleAddTeams}
      />
    </Container>
  );
}

const Container = styled.div`
  .blocked {
    background-color: ${colors.gray.third};
    color: ${colors.gray.first};
    pointer-events: none;
  }
  .list-table {
    /* background: ; */
    display: flex;
    flex-direction: column;
    .t-header {
      background-color: ${colors.gray.second};
      display: grid;
      grid-template-columns: 0.6fr 0.8fr 1fr 1.2fr;
      > * {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    ul.member-list {
      > li {
        display: grid;
        grid-template-columns: 0.6fr 0.8fr 1fr 1.2fr;

        .check-container {
          svg {
            color: ${colors.gray.second};
          }
          /* background-color: coral; */
          /* &.active {
            svg {
              color: ${colors.green.first};
            }
          } */
        }
      }
    }
    .item {
      border: 1px solid black;
      padding: 2.5px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      word-break: break-all;
    }
  }

  /* Add Jo Modal Styles */
  .addjo-page {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
  }

  .addjo-modal {
    display: flex;
    width: 340px;
    padding-top: 24px;
    align-items: center;
    gap: 10px;
    border-radius: 6px;
    background: var(--teeshot-white, #fdfdfd);
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
    height: 292px;
    flex-direction: column;
    position: relative;
  }

  .addjo-modal-container {
    display: flex;
    width: 340px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    flex-shrink: 0;
    position: relative;
  }

  .addjo-modal-content {
    display: flex;
    width: 290px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    position: relative;
  }

  .addjo-modal-title {
    align-self: stretch;
    color: var(--teeshot-black, #1a1a1a);
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    position: relative;
    margin: 0;
  }

  .addjo-options-container {
    display: flex;
    width: 290px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    position: relative;
  }

  .addjo-option-button {
    display: flex;
    height: 40px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 6px;
    background: var(--teeshot-white, #fdfdfd);
    position: relative;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    padding: 0;
  }

  .addjo-option-button.default {
    border: 0.5px solid var(--teeshot-g2, #d1d5d8);
  }

  .addjo-option-button.active {
    border: 0.5px solid var(--teeshot-active, #007bff);
  }

  .addjo-option-content {
    display: flex;
    width: 290px;
    padding: 10px 8px;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    height: 40px;
    box-sizing: border-box;
  }

  .addjo-option-left {
    display: flex;
    align-items: center;
    gap: 6px;
    position: absolute;
    left: 8px;
    top: 10px;
    height: 20px;
  }

  .addjo-option-text {
    color: var(--teeshot-black, #1a1a1a);
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-left: 6px;
  }

  .check-circle-wrapper {
    width: 20px;
    height: 20px;
    position: relative;
  }

  .check-circle-background {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    background: #d9d9d9;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 50%;
    opacity: 0;
  }

  .check-circle-icon {
    flex-shrink: 0;
    position: absolute;
    left: 2px;
    top: 2px;
    transition: fill 0.2s ease;
  }

  .check-circle-icon.active {
    left: 1px;
    top: 1px;
  }

  .addjo-modal-buttons {
    display: flex;
    height: 60px;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    position: relative;
    margin-top: auto;
  }

  .addjo-cancel-button {
    display: flex;
    width: 170px;
    height: 60px;
    padding: 16px 46px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 0 0 0 6px;
    background: var(--teeshot-g1, #79818a);
    border: none;
    cursor: pointer;
    transition: background 0.2s ease;
    color: var(--teeshot-white, #fdfdfd);
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
  }

  .addjo-cancel-button:hover {
    background: #6b7580;
  }

  .addjo-select-button {
    display: flex;
    width: 170px;
    height: 60px;
    padding: 16px 46px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 0 0 6px 0;
    background: var(--teeshot-green, #004b49);
    border: none;
    cursor: pointer;
    transition: background 0.2s ease;
    color: var(--teeshot-white, #fdfdfd);
    text-align: center;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
  }

  .addjo-select-button:hover {
    background: #003a38;
  }
`;
